import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[only-number]' // Attribute selector
})
export class OnlyNumberDirective {
  @HostListener('‘keypress’')
  onkeypress(e) {
    console.log('keypress');
    let event = e || window.event;
    if (event) {
      return this.isNumberKey(event);
    }
  }
  isNumberKey(event) {
    let charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/directives/only-number/only-number.ts